<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>This book is dedicated to my own amazing unit: my wife, Tara, and our three troopers, Sam, Jude, and Liberty. It is also for all the dads who kept asking, “Have you written that book yet? I really need a copy.”</p>
<p class="acknowledgements">Thank you all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?c047ae4c